import * as Stores from '../stores'
import { useEffect } from 'react'
import { useActiveApplication } from './useActiveApplication'
import { isResolvedPlatform, useCardApplicationPlatform } from './useCardApplicationPlatform'

export function useCreateApplicationIfNeeded() {
  const { activeApplicationStatus } = useActiveApplication()
  const platform = useCardApplicationPlatform()
  const [createApplication, createApplicationStatus] =
    Stores.CardApplicationApi.endpoints['POST /card/onboarding/applications'].useMutation()

  const shouldCreateApplication =
    activeApplicationStatus === 'NOT_FOUND' &&
    isResolvedPlatform(platform) &&
    platform !== 'HIGHNOTE' && // TODO: If we ever bring Highnote into the new Platform stack, we'll need to remove this.
    createApplicationStatus.isUninitialized

  useEffect(() => {
    // Claude: `createApplicationStatus.isUninitialized` should gate us from calling multiple times.
    if (shouldCreateApplication) {
      void createApplication({
        body: {
          platform,
        },
      })
    }
  }, [platform, shouldCreateApplication, createApplication])

  return { createApplicationStatus }
}
